import styles from './style.module.scss';
import { Image, Typography, Space, Divider, Row, Col, Card, Spin } from 'antd';
import { PageHeader } from 'components';
import uuid from 'react-uuid';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import usePromotions from '../../../../promo/subPages/promotions/usePromotions';

const SinglePromotion = () => {
  const { t } = useTranslation();

  const { singleItem } = usePromotions(false);

  const download = (e) => {
    e.preventDefault();
    fetch(e.target.href, {
      method: 'GET',
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'image.png'); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Change this when front-end will be deployed on same domain as back-end
  const imageUrl = singleItem?.allData?.image;
  const showPreview = singleItem?.allData?.image_show_preview;

  return singleItem ? (
    <div>
      <PageHeader title={singleItem.title} />
      <div className={styles.content}>
        <Card loading={false} title={singleItem.title}>
          <Card.Grid className={styles.rightSide} hoverable={false}>
            <Row>
              <Col flex='200px'>
                <Typography.Text strong>{t('Titolo IT')}:</Typography.Text>
              </Col>
              <Col>{singleItem.title_it}</Col>
            </Row>
            <Row>
              <Col flex='200px'>
                <Typography.Text strong>{t('Titolo EN')}:</Typography.Text>
              </Col>
              <Col>{singleItem.title_en}</Col>
            </Row>
            <Row>
              <Col flex='200px'>
                <Typography.Text strong>{t('Titolo FR')}:</Typography.Text>
              </Col>
              <Col>{singleItem.title_fr}</Col>
            </Row>
            <Divider />
            <Row>
              <Col flex='200px'>
                <Typography.Text strong>{t('Descrizione IT')}:</Typography.Text>
              </Col>
              <Col>{singleItem.description_it}</Col>
            </Row>
            <Row>
              <Col flex='200px'>
                <Typography.Text strong>{t('Descrizione EN')}:</Typography.Text>
              </Col>
              <Col>{singleItem.description_en}</Col>
            </Row>
            <Row>
              <Col flex='200px'>
                <Typography.Text strong>{t('Descrizione FR')}:</Typography.Text>
              </Col>
              <Col>{singleItem.description_fr}</Col>
            </Row>
            <Divider />
            <Row>
              <Col span={6}>
                <Space direction={'vertical'} size={[4]}>
                  <Typography.Text strong>
                    {t('Data inizio promozione')}
                  </Typography.Text>
                  <Typography.Text>
                    {singleItem.from &&
                      moment(singleItem.from).format('DD MMMM YYYY')}
                  </Typography.Text>
                </Space>
              </Col>
              <Col span={6}>
                <Space direction={'vertical'} size={[4]}>
                  <Typography.Text strong>
                    {t('Data fine promozione')}
                  </Typography.Text>
                  <Typography.Text>
                    {singleItem.to &&
                      moment(singleItem.to).format('DD MMMM YYYY')}
                  </Typography.Text>
                </Space>
              </Col>
              <Col span={6}>
                <Space direction={'vertical'} size={[4]}>
                  <Typography.Text strong>
                    {t('Fino esaurimento scorte')}
                  </Typography.Text>
                  <Typography.Text>
                    {singleItem.until_last ? t('Yes') : t('No')}
                  </Typography.Text>
                </Space>
              </Col>
              <Col span={6}>
                <Space direction={'vertical'} size={[4]}>
                  <Typography.Text strong>
                    {t('Solo dipendenti')}
                  </Typography.Text>
                  <Typography.Text>
                    {singleItem.staff_only ? t('Yes') : t('No')}
                  </Typography.Text>
                </Space>
              </Col>
            </Row>
            <Divider />
            <Row>
              <Col flex='200px'>
                <Typography.Text strong>{t('Insegna')}:</Typography.Text>
              </Col>
              <Col>{singleItem.company}</Col>
            </Row>
            <Divider />
            {imageUrl ? (
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Typography.Text strong>{t('ALLEGATO')}</Typography.Text>
                </Col>
                <Col key={uuid()}>
                  <Space direction={'vertical'}>
                    {showPreview && <Image width={200} src={imageUrl} />}

                    <a href={imageUrl} onClick={download}>
                      {t('Scarica')}
                    </a>
                  </Space>
                </Col>
              </Row>
            ) : (
              <Spin size={'medium'} />
            )}
          </Card.Grid>
        </Card>
      </div>
    </div>
  ) : (
    <Spin size={'large'} />
  );
};

export default SinglePromotion;
